import { EO_CLICK, EO_OPEN, REVENUE } from '../../../../../common/support/eo_mapping/datasources';
import { EMAIL_EVENT_LIST } from '../utils';

export default class EmailsTimeSeriesService {
  static getDefaultDataSources = (hasRevenueEvents: boolean) => [hasRevenueEvents ? REVENUE : EO_CLICK];

  static getDefaultSummaryDataSources = (hasRevenueEvents: boolean) => [hasRevenueEvents ? REVENUE : EO_OPEN];

  static getFilteredEventList = () => EMAIL_EVENT_LIST.filter((e) => e !== 'JOURNEYS_DISMISSAL');
}
